import domains from '_static/domains.json'
import i18n from '@/plugins/i18n'
import { ASPNET_APPLICATION_COOKIE_NAME, API_TOKEN_COOKIE_NAME } from '@/constants/cookies'
import { inOpenlegal } from '@/constants/platformNames'
import { country, environment, getPortal, inLocalEnv, inDevelopmentEnv, inStagingEnv, inProductionEnv, inMx } from '@/helpers/global.helpers'

export function getAppUrl (path = '', portal = null) {
		return `https://${portal || getPortal()}${(!(path.indexOf('api/') > -1) ? `/${i18n.locale}` : '')}/${path}`
}

export function getPatientAppUrl (path = '') {
	return getAppUrl(`HomePaciente/#/${path}`)
}

export function getCustomPageUrl (url, path) {
	if (!url) {
		return ''
	}
	let apiToken = window.$cookies.get(API_TOKEN_COOKIE_NAME)
	return `${url}/${i18n.locale}${path || ''}?host=${encodeURIComponent(getPortal())}${apiToken ? `&token=${apiToken}` : ''}${inMx ? '&mx=1' : ''}`
}

export function getMenttumUrl () {
	return `${inMx ? inDevelopmentEnv || inStagingEnv ? domains.appV2DomainMX : domains.appTestV2DomainMX : inDevelopmentEnv || inStagingEnv ? domains.appV2DomainES : domains.appTestV2DomainES}/patient/menttum`
}

export function getV2AppUrl (path = '', forceEs = false, forceMx = false) {
		let v2AppDomain
		let isMxLink = ((inMx || forceMx) && !forceEs)
		if (inLocalEnv){
				v2AppDomain = domains.appV2LocalDomain
		} else if (inDevelopmentEnv) {
				v2AppDomain = isMxLink ? domains.appDevV2DomainMX : domains.appDevV2DomainES
		} else if (inStagingEnv) {
				v2AppDomain = isMxLink ? domains.appTestV2DomainMX : domains.appTestV2DomainES
		} else {
				v2AppDomain = isMxLink ? domains.appV2DomainMX : domains.appV2DomainES
		}
		return `${v2AppDomain}/${i18n.locale}/${path}`
}

export function getApiUrl (path = '') {
		const v2AppDomain = inLocalEnv ? domains.apis.api.local : inDevelopmentEnv ? (inMx ? domains.apis.api.mx.development : domains.apis.api.es.development) : inStagingEnv ? (inMx ? domains.apiTestDomainMX : domains.apiTestDomainES) : (inMx ? domains.apiDomainMX : domains.apiDomainES)
		return `${v2AppDomain}/${path}`
}

export function getDomainsJsonUrl (key, path = '', queryParams = {}) {
		let domain
		if (inLocalEnv){
				domain = domains[key].local
		} else {
				domain = domains[key][country][environment]
		}
		// Add query parameters to the URL if provided
		if (Object.keys(queryParams).length > 0) {
				const queryString = new URLSearchParams(queryParams).toString()
				path += `?${queryString}`
		}
		return `${domain}/${i18n.locale}/${path}`
}

export function get360AppUrl (path = '', queryParams = {}) {
		return getDomainsJsonUrl('360', path, queryParams)
}

export function getHealthyCommunityUrl (path = '') {
		return getDomainsJsonUrl('healthy-community', path)
}

export function getHabitsUrl (path = '') {
		return getDomainsJsonUrl('habits', path)
}

export function getPatientsLikeYouUrl (path = '') {
		return getDomainsJsonUrl('patients-like-you', path)
}

export function getSubdomain () {
		return inDevelopmentEnv ? domains['testSubdomain'] : window.location.hostname.split('.')[0]
}

export function getRelativeHref (path, relativePath) {
		if (inProductionEnv) {
		return path
		} else {
		return `/${relativePath}/${path}`
		}
}

export function goToWebApp (path = '', token = null, portal = null) {
		let url = getAppUrl(path, portal)
		window.location.href = !window.$cookies.get(ASPNET_APPLICATION_COOKIE_NAME) && token ? getApiLoginToUrl(token, url, portal) : url
}

export function goToPatientWebApp (path = '', token = null) {
		goToWebApp(`Home${inOpenlegal() ? 'Cliente': 'Paciente'}/#/${path}`, token)
}

export function goToProfessionalWebApp(path = '', token = null) {
		goToWebApp(`Home${inOpenlegal() ? 'Abogado': 'Profesional'}/#/${path}`, token)
}

export function goToCenterWebApp(path = '', token = null) {
		goToWebApp(`Home${inOpenlegal() ? 'Bufete': 'Centro'}/#/${path}`, token)
}

export function goToAdminWebApp(path = '', token = null) {
		goToWebApp(`HomeAdmin/${path}`, token)
}

export function getApiLoginToUrl(token, url, portal = null) {
	return `${getAppUrl(`Account/ApiLoginToUrl?token=${token}&url=${encodeURIComponent(url)}&referer=${encodeURIComponent(window.location.host)}`, portal)}`
}

export function goToHabits() {
	window.open(getHabitsUrl(), '_blank')
}

export function goToForum () {
	window.open(getHealthyCommunityUrl('pacientescomotu'), '_blank')
}

export function goToACAUrl () {
	window.location.href = domains.tarjetaACA[environment]
}

export function goToBlog () {
	window.location.href = domains.blog
}

export function getProfessionalsLandingUrl () {
	return inMx ? '/profesionales' : `https://prime.opensalud.es/${i18n.locale}/profesionales`
}

export function goToProfessionalsLanding () {
	window.location = getProfessionalsLandingUrl()
}
export function goTo360 () {
	window.location.href = get360AppUrl('')
}

export default {
	getAppUrl,
	getPatientAppUrl,
	getV2AppUrl,
	getApiUrl,
	getDomainsJsonUrl,
	get360AppUrl,
	getHealthyCommunityUrl,
	getHabitsUrl,
	getPatientsLikeYouUrl,
	getMenttumUrl,
	getSubdomain,
	getRelativeHref,
	goToWebApp,
	goToPatientWebApp,
	goToProfessionalWebApp,
	goToCenterWebApp,
	goToAdminWebApp,
	getApiLoginToUrl,
	goToHabits,
	goToForum,
	getCustomPageUrl,
	goToACAUrl,
	goToBlog,
	getProfessionalsLandingUrl,
	goToProfessionalsLanding,
	goTo360
}


// WEBPACK FOOTER //
// ./src/helpers/app.helpers.js